module.exports = __webpack_public_path__ + "img/25.d2e86b65.png";